module.exports = __webpack_public_path__ + "static/media/triangle-2.ac6ad4cf.svg";